import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPencil: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPencil"><Path d="M16.2324 2.56036C17.2087 1.58405 18.7916 1.58405 19.7679 2.56036L21.4395 4.23193C22.4158 5.20824 22.4158 6.79115 21.4395 7.76746L18.7071 10.4998L13.5 5.29274L16.2324 2.56036Z" fill="currentColor"/><Path d="M12.7927 5.99988L2.43934 16.3533C2.15803 16.6346 2 17.0161 2 17.4139V21.4997C2 21.7759 2.22386 21.9997 2.5 21.9997H6.58579C6.98361 21.9997 7.36514 21.8417 7.64645 21.5604L17.9998 11.207L12.7927 5.99988Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPencil;
